import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ScrollToTopButton() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label={t("common.scrollToTop")}
      className={`fixed bottom-8 right-6 z-50 w-11 h-11 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 whitespace-nowrap
        bg-[#D4AF37] hover:bg-[#c09e2a] text-[#0A1628]
        ${visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"}
      `}
      style={{ boxShadow: "0 4px 16px rgba(212,175,55,0.35)" }}
    >
      <i className="ri-arrow-up-line text-lg font-bold" />
    </button>
  );
}
